<template>
<base-modal
  :is-visible="isVisible"
  @hideModal="hideModal()"
  :is-editable="false"
  :is-archivable="false"
  size="xl"
>
  <template #header>
    {{ $t('routes.UserDataCreate') }}
  </template>
  <template #body>
    <create :clientType="clientType"></create>
  </template>
</base-modal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Create from '@/components/Dashboard/Views/userdata/Create'

export default {
  name: 'CreateModal',
  components: {
    BaseModal,
    Create
  },

  props: ['clientType'],

  computed: {
    ...mapGetters({
      isVisible: 'userdata/createModal/isVisible',
      created: 'userdata/create/created'
    })
  },

  watch: {
    created (val) {
      if (val) this.hideModal()
    }
  },

  methods: {
    hideModal () {
      this.reset()
      this.toggleModal()
    },
    ...mapActions({
      reset: 'userdata/create/reset'
    }),
    ...mapMutations({
      toggleModal: 'userdata/createModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
